/*
 * PWA Service Worker registration helper
 * - Registers serviceWorker.js on production builds
 * - Handles update found → installs new worker and prompts to refresh
 * - Exposes small event bus on window.PWA for UI components
 */

// Lightweight event bus for PWA-related UI
function createBus() {
  const listeners = {}
  return {
    on(event, cb) {
      (listeners[event] ||= []).push(cb)
    },
    off(event, cb) {
      const arr = listeners[event]
      if (!arr) return
      const idx = arr.indexOf(cb)
      if (idx >= 0) arr.splice(idx, 1)
    },
    emit(event, payload) {
      (listeners[event] || []).forEach((cb) => {
        try { cb(payload) } catch {}
      })
    },
  }
}

export function registerServiceWorker() {
  if (typeof window === 'undefined') return
  if (!('serviceWorker' in navigator)) return

  // expose PWA bus and install prompt holder
  if (!window.PWA) window.PWA = { bus: createBus(), deferredPrompt: null }

  // capture install prompt for UI
  window.addEventListener('beforeinstallprompt', (e) => {
    e.preventDefault()
    window.PWA.deferredPrompt = e
    window.PWA.bus.emit('can-install', true)
  })
  window.addEventListener('appinstalled', () => {
    window.PWA.deferredPrompt = null
    window.PWA.bus.emit('installed')
  })

  const swUrl = `${import.meta.env.BASE_URL || '/'}serviceWorker.js`

  navigator.serviceWorker
    .register(swUrl)
    .then((registration) => {
      console.info('[PWA] SW registered:', registration.scope)

      // Listen for updates
      registration.addEventListener('updatefound', () => {
        const newWorker = registration.installing
        if (!newWorker) return
        newWorker.addEventListener('statechange', () => {
          if (newWorker.state === 'installed') {
            const hasController = navigator.serviceWorker.controller
            if (hasController) {
              // New content available
              window.PWA.bus.emit('update-available', {
                refresh() {
                  newWorker.postMessage({ type: 'SKIP_WAITING' })
                },
              })
            } else {
              // Content cached for offline use
              window.PWA.bus.emit('cached')
            }
          }
        })
      })

      // When the new SW has skipped waiting, reload to activate
      navigator.serviceWorker.addEventListener('controllerchange', () => {
        window.location.reload()
      })
    })
    .catch((err) => {
      console.warn('[PWA] SW registration failed', err)
    })
}
